import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import QualityGrid from "@/components/QualityGrid";
import { IMAGES } from "@/lib/data";
import { useLang } from "@/i18n";

export default function Quality() {
  const { t } = useLang();

  return (
    <>
      <SEO
        title="Quality & Certifications — Standards for Cross-Border Trust | Farmsons"
        description="Farmsons builds cross-border trust through traceable sourcing, export-grade grading, cold-chain integrity and compliance-ready documentation for international produce trade."
        keywords="export grade fruit India, traceable sourcing, cold chain produce, phytosanitary compliance, produce quality standards"
      />
      <PageHeader
        overline={t("qualityPage.overline")}
        title={t("qualityPage.title")}
        lede={t("qualityPage.lede")}
        image={IMAGES.appleCrate}
        imageAlt="Graded apples in a crate, illustrating Farmsons' export-grade quality standards"
      />
      <section className="pb-24 md:pb-32 bg-[#fdfbf5]">
        <QualityGrid />
      </section>
    </>
  );
}
